<div
  class="title-container"
  nz-popover
  nzPopoverTrigger="click"
  [nzPopoverContent]="megaMenuTemplate"
  nzPopoverPlacement="bottomLeft"
  nzPopoverOverlayClassName="industry-megamenu-popover"
  [nzPopoverBackdrop]="true"
  [(nzPopoverVisible)]="isMegaMenuVisible"
  (nzPopoverVisible)="handlePopoverVisibilityChange($event)"
>
  <div
    class="page-title"
    [ngClass]="{
      'menu-open': isMegaMenuVisible
    }"
  >
    <div class="industry-icon">
      <span class="icon-box">
        <va-icon
          size="small"
          name="sliders-horizontal"
          class="my-class"
        ></va-icon>
      </span>
      <span class="icon-notch"></span>
    </div>
    <div
      class="industry-cluster-name"
      *ngIf="selectedSector && selectedIndustry"
    >
      <div class="title">{{ selectedSector }}&nbsp;</div>
      <div class="title">
        <span> - {{ selectedIndustry }} </span>
        <span *ngIf="selectedClusterText"> - {{ selectedClusterText }} </span>
        <span *ngIf="selectedGeographyText" class="light-title">
          | {{ selectedGeographyText }}
        </span>
        <span *ngIf="selectedMarketCapText" class="light-title">
          | {{ selectedMarketCapText }}
        </span>
      </div>
    </div>
  </div>
</div>

<ng-template #megaMenuTemplate>
  <app-industry-mega-menu
    (close)="onClose()"
    [isMegaMenuVisible]="isMegaMenuVisible"
  ></app-industry-mega-menu>
</ng-template>
